import * as React from 'react'

import { cn } from '@/lib'
import { Label } from './Label'

export interface TextareaProps
	extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	label?: React.ReactNode
	error?: React.ReactNode
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ className, label, error, ...props }, ref) => {
		return (
			<div className="flex flex-col gap-1 relative">
				{label && <Label className="mb-1">{label}</Label>}
				<textarea
					className={cn(
						'flex min-h-[80px] w-full rounded-xs border border-input bg-background px-3 py-2 text-lg font-medium ring-offset-background',
						'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
						'disabled:cursor-not-allowed disabled:opacity-50',
						'placeholder:text-muted-foreground',
						!!error && 'border-red-500',
						className,
					)}
					ref={ref}
					{...props}
				/>
				{error && <p className="text-red-500 text-sm">{error}</p>}
			</div>
		)
	},
)
Textarea.displayName = 'Textarea'

export { Textarea }
